module.exports = __webpack_public_path__ + "img/shrimp_th_new_0003.1e558cc7.png";